// Add :external selector
$.expr[':'].external = function(obj){
	return (!obj.href.match(/^mailto\:/)
			&& (obj.hostname != location.hostname)
			&& !obj.href.match(/^javascript\:/)
			&& !obj.href.match(/^$/))
	|| obj.href.match(/\.pdf$/)
};

$(document).ready(function(){
	// Add target _blank
	$('a:external').attr('target', '_blank');

	headerScroll();

	if ($('.home').length)
		home();

	if ($('.toggle').length)
		toggles();

	if ($('.single-cabin').length)
		singleCabin();

	if ($('.single-group').length)
		singleGroup();

	if ($('.single-commission').length)
		singleCommission();

	if ($('.single-sub-section').length)
		singleSubSection();

	if ($('.single-activity').length)
		singleActivity();

	if ($('.post-type-archive-activity').length)
		activityFilters();

	if ($('.post-type-archive-cabin').length)
		cabinFilters();

	if ($('.display').length)
		display();

	if ($('.post-type-archive-journal').length)
		journalFuncs();

	if ($('.section-news_slider').length)
		newsSlider();

	square();
	removeOneSlideNav();
	search();
})

// Add light shadow when navigation is in front of content
function headerScroll(){
	var currentScroll = 0;
	var hasShadow = false;
	handleShadow();
	$(document).on('scroll', handleShadow);
	$(window).on('resize', handleShadow);

	function handleShadow(){
		currentScroll = $(document).scrollTop();

		var headerImage = $('.featured-image-header');
		var nav = $('.site-branding-container');

		// We don't need shadow if in front of header image
		if (currentScroll + nav.position().top + nav.height() > headerImage.offset().top + headerImage.height()){
			// Check to avoid adding class each scroll, not really necessary but probably faster?
			if (!hasShadow){
				hasShadow = true;
				$('body').addClass('has-shadow');
			}
		}else{
			if (hasShadow){
				hasShadow = false;
				$('body').removeClass('has-shadow');
			}
		}
	}
}

function home(){
	if ( !Modernizr.touchevents ) {
		// Activities
		$('.activities .activities-slider-nav').flexslider({
			animation: "slide",
			controlNav: false,
			slideshow: false,
			itemWidth: 300,
			itemMargin: 20,
			animationLoop: false,
			nextText: '',
			prevText: '',
			smoothHeight: false,
			asNavFor: '.activities .activities-slider',
			start: function(slider){
				$('li', slider).show().find('img').css('position', 'relative');
			}
		});
	}else{
		// Activities
		$('.activities .activities-slider-nav').flexslider({
			animation: "slide",
			controlNav: false,
			slideshow: false,
			itemWidth: 300,
			itemMargin: 20,
			animationLoop: false,
			nextText: '',
			prevText: '',
			smoothHeight: false,
			start: function(slider){
				$('li', slider).show().find('img').css('position', 'relative');
			}
		});
	}

	$('.activities .activities-slider').flexslider({
		animation: "slide",
		controlNav: false,
		slideshow: false,
		directionNav: false,
		animationLoop: false,
		nextText: '',
		prevText: '',
		smoothHeight: false,
		sync: ".activities .activities-slider-nav",
		start: function(slider){
			$('li', slider).show().find('img').css('position', 'relative');
		}
	});

	if ( !Modernizr.touchevents ) {
		// Cabins slider
		$('.cabins .cabins-slider-nav').flexslider({
			animation: "slide",
			controlNav: false,
			slideshow: false,
			itemWidth: 300,
			itemMargin: 20,
			animationLoop: false,
			nextText: '',
			prevText: '',
			smoothHeight: false,
			asNavFor: '.cabins .cabins-slider',
			start: function(slider){
				$('li', slider).show().find('img').css('position', 'relative');
			}
		});
	}else{
		// Cabins slider
		$('.cabins .cabins-slider-nav').flexslider({
			animation: "slide",
			controlNav: false,
			slideshow: false,
			itemWidth: 300,
			itemMargin: 20,
			animationLoop: false,
			nextText: '',
			prevText: '',
			smoothHeight: false,
			start: function(slider){
				$('li', slider).show().find('img').css('position', 'relative');
			}
		});
	}
	$('.cabins .cabins-slider').flexslider({
		animation: "slide",
		controlNav: false,
		slideshow: false,
		directionNav: false,
		animationLoop: false,
		nextText: '',
		prevText: '',
		smoothHeight: false,
		sync: ".cabins .cabins-slider-nav",
		start: function(slider){
			$('li', slider).show().find('img').css('position', 'relative');
		}
	});

	// Social form
	var form = $('.social-form');
	var socialCTA = $('.social-cta');
	$('.social-cta .open-form').on('click', function(){
		if (!form.is(':visible')){
			var formTop = socialCTA.offset().top + socialCTA.outerHeight();
			formTop -= $('.site-branding-container').height() + $('.site-branding-container').position().top;

			$('html, body').stop().animate({ scrollTop: formTop }, 300);
		}

		form.stop().slideToggle(300);
	})

	// Refresh ig cache if needed
	var cacheValid = $('.instagram-feed').data('cache-valid');
	if ('false' == cacheValid || false == cacheValid){
		var data = {
			action: 'ig_medias_html_ajax',
			number_media: 5,
		}
		$.post(urls.ajax, data, function(response){
			$('.instagram-feed .boxed').empty().append(response);
		})
	}

	// Program bg position
	programBgPosition();
	$(window).on('resize', programBgPosition);
	function programBgPosition() {
		var windowW = $(window).width();
		console.log(windowW)
		var programW = $('.program-grid').width();
		console.log(programW)
		$('.program-grid .bg').css({
			left: -(windowW-programW) / 2,
			width: windowW,
		})
	}
}

function toggles(){
	$('.toggle').each(function(){
		var toggle = $(this);
		$('.toggle-title', toggle).on('click', function(){
			toggle.toggleClass('active');
			$('.toggle-content', toggle).stop().slideToggle(300);
		})
	})
}

function singleCabin(){
	// Geo admin map
	if ($('.geo-map.geo-map-ready').length){
		var layer = ga.layer.create('ch.swisstopo.pixelkarte-farbe');
		$('.geo-map.geo-map-ready').each(function(i){
			var id = 'geo-map-'+i;
			$(this).attr('id', id);
			var coordinates = $(this).data('coordinates').split(',');
			var map = new ga.Map({
				target: id,
				layers: [layer],
				view: new ol.View({
					resolution: 2,
					center: coordinates // CH1903+ (EPSG:2056)
				})
			});

			var iconFeature = new ol.Feature({
				geometry: new ol.geom.Point(coordinates),
			});

			var iconStyle = new ol.style.Style({
				image: new ol.style.Icon(({
					src: urls.theme + '/img/ui/icon-marker.png',
					anchor: [0.5, 1],
				}))
			});
			iconFeature.setStyle(iconStyle);

			var vectorSource = new ol.source.Vector({
				features: [iconFeature]
			});

			var vectorLayer = new ol.layer.Vector({
				source: vectorSource
			});
			map.addLayer(vectorLayer);
		})
	}

	// Gallery
	if ($('.gallery-masonry').length){
		console.log(Fancybox)
		Fancybox.defaults.l10n = {
			CLOSE: "Fermer",
			NEXT: "Suivant",
			PREV: "Précédent",
			MODAL: "Vous pouvez fermer cette fenêtre avec la touche ESC",
			ERROR: "Erreur de chargement, veuillez réessayer",
			IMAGE_ERROR: "Image non trouvée",
			ELEMENT_NOT_FOUND: "HTML Element Not Found",
			AJAX_NOT_FOUND: "Error Loading AJAX : Not Found",
			AJAX_FORBIDDEN: "Error Loading AJAX : Forbidden",
			IFRAME_ERROR: "Error Loading Page",
			TOGGLE_ZOOM: "Toggle zoom level",
			TOGGLE_THUMBS: "Toggle thumbnails",
			TOGGLE_SLIDESHOW: "Toggle slideshow",
			TOGGLE_FULLSCREEN: "Toggle full-screen mode",
			DOWNLOAD: "Télécharger",
		}
// 		Fancybox.bind('[data-fancybox="gallery"]', {
//   caption: function (fancybox, carousel, slide) {
//   	console.log('salut 1')
//     return (
//       `${slide.index + 1} / ${carousel.slides.length} <br />` + slide.caption
//     );
//   },
// });

		$('.gallery-masonry').justifiedGallery({
			rowHeight: 270,
			maxRowHeight: 270,
			margins: 22,
			lastRow: 'justify'
		});
	}

	// Anecdotes
	if ($('.section-full_width_slider').length){
		$('.section-full_width_slider .slider').flexslider({
			animation: "slide",
			controlNav: false,
			slideshow: false,
			directionNav: true,
			animationLoop: false,
			nextText: '',
			prevText: '',
			start: function(slider){
				$('li', slider).show().find('img').css('width', '100%');
			}
		});
	}

	// Featured posts
	if ($('.featured-cabins').length){
		$('.featured-cabins-slider').flexslider({
			animation: "slide",
			controlNav: false,
			slideshow: false,
			itemWidth: 310,
			itemMargin: 30,
			animationLoop: false,
			nextText: '',
			prevText: '',
			smoothHeight: false,
			start: function(slider){
				$('li', slider).show().find('img').css('width', '100%');
			}
		});
	}
}

function singleGroup(){
	// Featured posts
	if ($('.featured-groups').length){
		$('.featured-groups-slider').flexslider({
			animation: "slide",
			controlNav: false,
			slideshow: false,
			itemWidth: 310,
			itemMargin: 30,
			animationLoop: false,
			nextText: '',
			prevText: '',
			start: function(slider){
				$('li', slider).show().find('img').css('width', '100%');
			}
		});
	}
}

function singleCommission(){
	// Featured posts
	if ($('.featured-commissions').length){
		$('.featured-commissions-slider').flexslider({
			animation: "slide",
			controlNav: false,
			slideshow: false,
			itemWidth: 310,
			itemMargin: 30,
			animationLoop: false,
			nextText: '',
			prevText: '',
			start: function(slider){
				$('li', slider).show().find('img').css('width', '100%');
			}
		});
	}
}

function singleSubSection(){
	// Featured posts
	if ($('.featured-sub-sections').length){
		$('.featured-sub-sections-slider').flexslider({
			animation: "slide",
			controlNav: false,
			slideshow: false,
			itemWidth: 310,
			itemMargin: 30,
			animationLoop: false,
			nextText: '',
			prevText: '',
			start: function(slider){
				$('li', slider).show().find('img').css('position', 'relative');
			}
		});
	}
}

function singleActivity(){
	// Featured posts
	if ($('.featured-activities').length){
		$('.featured-activities-slider').flexslider({
			animation: "slide",
			controlNav: false,
			slideshow: false,
			itemWidth: 310,
			itemMargin: 30,
			animationLoop: false,
			nextText: '',
			prevText: '',
			start: function(slider){
				$('li', slider).show().find('img').css('width', '100%');
			}
		});
	}
}

function activityFilters(){
	if ($('.show-all').length)
		showAll();

	$('.filters .filter-item').on('click', function(event){
		event.preventDefault();
		getArchivePosts($(this).data('term'), 1);
	})

	function showAll(){
		$('.show-all').on('click', function(event){
			event.preventDefault();
			getArchivePosts($('.filter-item.active').data('term'), 2);
		})
	}

	function getArchivePosts(term, paged){
		var filterItem = $('.filter-item[data-term='+term+']');

		var filters = $('.filters-inner');
		filters.addClass('loading');
		$('.show-all').addClass('loading');

		var data = {
			action: 'get_term_archive',
			term: term,
			post_type: filters.data('post-type'),
			paged: paged,
		}

		$.post(urls.ajax, data, function(response){
			filters.removeClass('loading');
			$('.show-all').removeClass('loading');
			filterItem.addClass('active').siblings().removeClass('active');
			response = JSON.parse(response);

			history.replaceState(null, null, response.url);
			if (response.empty){
				var scrollTop = $('#content').offset().top - $('.site-branding-container').height();
				if ($('#wpadminbar').length)
					scrollTop = scrollTop - $('#wpadminbar').height();
				
				$('html, body').stop().animate({ scrollTop: scrollTop })
				$('.activitys').empty();
			}else{
				$('.btn-wrapper').remove();
			}
			
			$('.activitys').append(response.html);
			if ($('.show-all').length)
				showAll();
		})
	}
}

function cabinFilters(){
	if ($('.show-all').length)
		showAll();

	$('.filters .filter-item').on('click', function(event){
		event.preventDefault();
		getArchivePosts($(this).data('term'), 1);
	})

	function showAll(){
		$('.show-all').on('click', function(event){
			event.preventDefault();
			getArchivePosts($('.filter-item.active').data('term'), 2);
		})
	}

	function getArchivePosts(term, paged){
		var filterItem = $('.filter-item[data-term='+term+']');

		var filters = $('.filters-inner');
		filters.addClass('loading');
		$('.show-all').addClass('loading');

		var data = {
			action: 'get_term_archive',
			term: term,
			post_type: filters.data('post-type'),
			paged: paged,
		}

		$.post(urls.ajax, data, function(response){
			filters.removeClass('loading');
			$('.show-all').removeClass('loading');
			filterItem.addClass('active').siblings().removeClass('active');
			response = JSON.parse(response);

			history.replaceState(null, null, response.url);
			if (response.empty){
				var scrollTop = $('#content').offset().top - $('.site-branding-container').height();
				if ($('#wpadminbar').length)
					scrollTop = scrollTop - $('#wpadminbar').height();
				
				$('html, body').stop().animate({ scrollTop: scrollTop })
				$('.cabins').empty();
			}else{
				$('.btn-wrapper').remove();
			}
			
			$('.cabins').append(response.html);
			if ($('.show-all').length)
				showAll();
		})
	}
}

function display(){
	$('.display .icon').on('click', function(event){
		event.preventDefault();

		$('body').removeClass('display-list display-block').addClass($(this).data('display'));
	})
}

function journalFuncs(){
	// Show hidden
	if ($('.show-hidden').length)
		showHidden();

	journalFilters();
}

function showHidden(){
	$('.show-hidden').on('click', function(){
		$(this).slideUp(300);
		$(this).siblings('.hidden').slideDown(300);
	})
}

function journalFilters(){
	$('.filters .filter-item').on('click', function(event){
		event.preventDefault();
		getArchivePosts($(this), $(this).data('year'), $(this).closest('.bulletins-wrapper').length);
	})

	function getArchivePosts(filterItem,year, isBulletin){
		var filters = filterItem.closest('.filters-inner');
		filters.addClass('loading');

		var data = {
			action: 'get_archive_journal',
			year: year,
			is_bulletin: isBulletin,
		}

		$.post(urls.ajax, data, function(response){
			filters.removeClass('loading');
			filterItem.addClass('active').siblings().removeClass('active');
			
			$('.bulletin-'+isBulletin+' .boxed').empty().append(response);
		})
	}
}

function newsSlider(){
	// News slider
	if ($('.section-news_slider').length){
		$('.section-news_slider .slider').flexslider({
			animation: "slide",
			controlNav: false,
			slideshow: false,
			directionNav: true,
			animationLoop: false,
			nextText: '',
			prevText: '',
			start: function(slider){
				$('li', slider).show().find('img').css('width', '100%');
			}
		});
	}
}

function square(){
	if (!$('ul').length)
		return;

	$('ul').each(function(){
		if ('square' != $(this).css('list-style-type'))
			return true;

		$(this).addClass('square').css('list-style-type', 'none');

		$('li', this).on('click', function(){
			$(this).toggleClass('checked');
		})
	})
}

// Remove sliders nav if there's only one slide
function removeOneSlideNav(){
	if (!$('.flex-direction-nav').length)
		return;
	$('.flex-direction-nav').each(function(){
		if (2 === $('.flex-disabled', this).length)
			$(this).remove();
	})
}

function search() {
	var $openSearch = $('.open-search');
	if (!$openSearch.length)
		return;

	$openSearch.on('click', function() {
		$('.search-form').stop().slideToggle(300);
		$('.search-form .search-field').focus();
	})
}